module.exports = __webpack_public_path__ + "img/big_PC.8ddaf25e.jpg";